import { useState, useEffect } from 'react';
import { Plus, Pencil, Building2 } from 'lucide-react';
import { publicidadService } from '../../../services/api';
import styles from './PublicidadTab.module.css';

const EMPTY = { razonSocial:'', nit:'', nombreContacto:'', emailContacto:'', telefono:'', esAgencia:false, descuentoEspecialPct:'', notas:'' };

export default function AnunciantesTab() {
  const [items, setItems]   = useState([]);
  const [form, setForm]     = useState(EMPTY);
  const [editing, setEditing] = useState(null);
  const [showing, setShowing] = useState(false);
  const [saving, setSaving]   = useState(false);
  const [msg, setMsg]         = useState(null);

  const load = () => publicidadService.getAnunciantes().then(setItems).catch(() => {});
  useEffect(() => { load(); }, []);

  const setField = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const openAdd  = () => { setForm(EMPTY); setEditing(null); setShowing(true); };
  const openEdit = (item) => {
    setForm({ ...item, descuentoEspecialPct: item.descuentoEspecialPct ?? '' });
    setEditing(item); setShowing(true);
  };
  const cancel = () => { setShowing(false); setEditing(null); };

  const save = async () => {
    if (!form.razonSocial.trim()) return setMsg({ type:'error', text:'La razón social es obligatoria.' });
    setSaving(true);
    try {
      const dto = { ...form, descuentoEspecialPct: form.descuentoEspecialPct === '' ? null : Number(form.descuentoEspecialPct) };
      if (editing) await publicidadService.actualizarAnunciante(editing.id, { ...dto, activo: true });
      else await publicidadService.crearAnunciante(dto);
      await load(); cancel();
      setMsg({ type:'ok', text:'Anunciante guardado.' });
    } catch { setMsg({ type:'error', text:'Error al guardar.' }); }
    setSaving(false);
  };

  return (
    <div>
      <div className={styles.sectionTitle} style={{ marginBottom:16 }}>
        <Building2 size={16} />
        Anunciantes
        <button className={styles.btnPrimary} onClick={openAdd} style={{ marginLeft:'auto' }}>
          <Plus size={13} /> Nuevo anunciante
        </button>
      </div>

      {msg && <div className={`${styles.msg} ${msg.type==='ok'?styles.msgOk:styles.msgError}`}>{msg.text}</div>}

      {showing && (
        <div className={styles.form}>
          <div className={styles.formGroup}>
            <label>Razón Social *</label>
            <input value={form.razonSocial} onChange={e => setField('razonSocial', e.target.value)} />
          </div>
          <div className={styles.formGroup}>
            <label>NIT</label>
            <input value={form.nit} onChange={e => setField('nit', e.target.value)} />
          </div>
          <div className={styles.formGroup}>
            <label>Contacto</label>
            <input value={form.nombreContacto} onChange={e => setField('nombreContacto', e.target.value)} />
          </div>
          <div className={styles.formGroup}>
            <label>Email</label>
            <input type='email' value={form.emailContacto} onChange={e => setField('emailContacto', e.target.value)} />
          </div>
          <div className={styles.formGroup}>
            <label>Teléfono</label>
            <input value={form.telefono} onChange={e => setField('telefono', e.target.value)} />
          </div>
          <div className={styles.formGroup}>
            <label>Descuento especial %</label>
            <input type='number' value={form.descuentoEspecialPct} onChange={e => setField('descuentoEspecialPct', e.target.value)} placeholder='Dejar vacío para usar el estándar' />
          </div>
          <div className={styles.formGroup} style={{ gridColumn:'1/-1' }}>
            <label>
              <input type='checkbox' checked={form.esAgencia} onChange={e => setField('esAgencia', e.target.checked)} style={{ marginRight:8 }} />
              Es agencia de medios
            </label>
          </div>
          <div className={styles.formGroup} style={{ gridColumn:'1/-1' }}>
            <label>Notas</label>
            <textarea rows={2} value={form.notas} onChange={e => setField('notas', e.target.value)} />
          </div>
          <div className={styles.formActions}>
            <button className={styles.btnOutline} onClick={cancel}>Cancelar</button>
            <button className={styles.btnPrimary} onClick={save} disabled={saving}>
              {saving ? 'Guardando...' : 'Guardar'}
            </button>
          </div>
        </div>
      )}

      {items.length === 0 && !showing ? (
        <div className={styles.empty}>No hay anunciantes registrados.</div>
      ) : (
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Razón Social</th><th>NIT</th><th>Contacto</th>
              <th>Email</th><th>Teléfono</th><th>Agencia</th>
              <th>Desc. %</th><th>Estado</th><th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {items.map(item => (
              <tr key={item.id}>
                <td><strong>{item.razonSocial}</strong></td>
                <td>{item.nit || '-'}</td>
                <td>{item.nombreContacto || '-'}</td>
                <td>{item.emailContacto || '-'}</td>
                <td>{item.telefono || '-'}</td>
                <td>{item.esAgencia ? '✓ Agencia' : '-'}</td>
                <td>{item.descuentoEspecialPct != null ? `${item.descuentoEspecialPct}%` : 'Estándar'}</td>
                <td><span className={`${styles.badge} ${item.activo ? styles.badgeActivo : styles.badgeInactivo}`}>{item.activo ? 'Activo':'Inactivo'}</span></td>
                <td>
                  <button className={styles.btnIcon} onClick={() => openEdit(item)}><Pencil size={12} /></button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
